import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {MdDialog, MdDialogRef} from '@angular/material';
import {AuthentificationService} from './authentification.service';
import {AppComponent} from './app.component';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';
import {WharehousesService} from './warehouses.service';

@Component({
    selector: 'authentification',
    styleUrls: ['./styles/authentification.component.css'],
    templateUrl: './templates/authentification.component.html',
    providers: [AuthentificationService, WharehousesService]
})


export class AuthentificationComponent {
    name = 'Authentification';
    societies_list: Array<Object>;
    society: any;
    user_name: string = "";
    password: string = "";
    connected: boolean = false;
    showForm: boolean = true;
    authentification_form: FormGroup;
    false_login: boolean = false;

    constructor(private authentification_service: AuthentificationService, private warehouse_service: WharehousesService, private app_component: AppComponent, private router: Router, private fb: FormBuilder) {
        this.createForm();
        this.CheckUSerSession();
        this.app_component.HideMenu();
        this.app_component.hide_infos = true;
        //this.left_menu.current_item = 0;
    }


    CheckUSerSession(): void {

        this.authentification_service.UserCheckSession().then(result => {
            if (result['id_user'] !== 0) {
                this.app_component.hide_infos = false;
                this.app_component.user_fname = result['user_firstname'];
                this.app_component.user_lname = result['user_lastname'];
                this.app_component.m_opened = true;
                this.router.navigate(['dashboard'])
            }
        });
    }

    createForm() {
        this.authentification_form = this.fb.group({
            user_name_ctrl: ['', Validators.required],
            password_ctrl: ['', Validators.required],
            society_ctrl: ['', Validators.required]
        });
    }

    /*GetSocietes(): void {
        this.authentification_service.GetSocities().then(result => {this.societies_list = result['list']; console.log(this.societies_list)});
    }*/

    GetWarehouses(): void {
        this.warehouse_service.GetWarehouses().then(result => {this.societies_list = result['list']; /*console.log(this.societies_list)*/});
    }

    ValidateIdentifiant(): void {
        //this.connected = true;
        if (this.authentification_form.status === 'VALID') {
            this.connected = true;

            this.authentification_service.ValidateAuthentification(this.user_name, this.password, this.society.name, this.society.id_warehouse).then(result => {
                //console.log(result);
                setTimeout(() => {
                    if (result['result'] === 'OK') {
                        this.app_component.hide_infos = false;
                        this.app_component.user_fname = result['user_firstname'];
                        this.app_component.user_lname = result['user_lastname'];
                        this.router.navigate(['dashboard']);
                        this.app_component.m_opened = true;
                    } else {
                        this.connected = false;
                        this.false_login = true;
                        setTimeout(() => {this.false_login = false;}, 4000);
                    }

                }, 2000);
                //setTimeout(() => {this.router.navigate(['dashboard']); this.app_component.m_opened = true;}, 2000);
            });
        }
    }


    /*IsValidForm(): void {
        //console.log(this.user_name + this.password + this.society);
        if (this.user_name !== "" && this.password !== "" && this.society !== "") {

        } else {

        }
    }*/

    Reset(): void {
        this.authentification_form.reset();
        this.showForm = false;
        setTimeout(() => {

            this.createForm();
            this.showForm = true;
        });

    }

    UserCheckSession(): void {
        this.authentification_service.UserCheckSession().then(result => {console.log(result)});
    }

    ngOnInit(): void {
        this.GetWarehouses();
    }

}






// WEBPACK FOOTER //
// ./src/app/authentification.component.ts